import { render, staticRenderFns } from "./BioData.vue?vue&type=template&id=19a14c93"
import script from "./BioData.vue?vue&type=script&lang=js"
export * from "./BioData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports